<template>
    <div>
        <template v-if="formDatas.ganda == 'tidak'">
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Pendataan dilakukan pada</span>
                <div class="col-12 mt-50 overflow-auto rounded">
                    <template v-if="formDatas.keberadaan == 'luar'">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Lokasi ID</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.lokasi_id || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Jalan / Nomor</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.jalan || '-' }} / {{ formDatas.detail_lokasi.no_jalan ||
                                    '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">RT / RW</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.rt || '-' }} / {{ formDatas.detail_lokasi.rw || '-'
                                }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kelurahan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_kel || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kecamatan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_kec || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kota / Kabupaten</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_rayon || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kode Pos</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.kodepos || '-' }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="formDatas.keberadaan == 'dalam'">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Ruangan ID</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.ruangan_id || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Gedung</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{
                                    `${(formDatas.detail_ruangan.kolok_gedung) ? formDatas.detail_ruangan.kolok_gedung :
                                        ''}${(formDatas.detail_ruangan.nalok_gedung) ? '::' +
                                            formDatas.detail_ruangan.nalok_gedung :
                                            ''}${(formDatas.detail_ruangan.noreg_gedung) ? '::' +
                                                formDatas.detail_ruangan.noreg_gedung :
                                                ''}${(formDatas.detail_ruangan.alamat_gedung) ? '::' +
                                                    formDatas.detail_ruangan.alamat_gedung : ''} ` || '-' }}
                                </span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Lantai</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.lantai || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Jenis Ruangan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.jenis_ruangan_nama || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Ruangan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.nama_ruangan || '-' }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Foto Barang</span>
                <div class="col-12 mt-50 overflow-auto rounded">
                    <ImageView :imgUrl="formDatas.file_foto_barang || ''" />
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Kondisi</span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.kondisi" value="baik" disabled>
                            Baik
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.kondisi" value="rusak-ringan" disabled>
                            Rusak Ringan
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.kondisi" value="rusak-berat" disabled>
                            Rusak Berat
                        </b-form-radio>
                    </div>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Kode dan Nama Barang</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ (formDatas.kobar_108 || '') + ' - ' + (formDatas.nabar_108 || '') || '-' }}</span>
                    </div>
                    <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                        <b-form-radio v-model="formDatas.is_m_kobar" value="sesuai" disabled>
                            Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_m_kobar" value="tidak-sesuai" disabled>
                            Tidak Sesuai
                        </b-form-radio>
                    </div>
                    <template v-if="formDatas.is_m_kobar == 'tidak-sesuai'">
                        <div style="margin-left: 25px;">
                            <div class="row mb-2">
                                <span class="col-12 font-weight-bold font-small-5 text-muted">KIB Seharusnya</span>
                                <div class="col-12 mt-50">
                                    <div class="border border-1 rounded p-75 bg-light">
                                        <span>{{ (formDatas.kib_seharusnya || '') + ' - ' + (formDatas.nama_kib_seharusnya
                                            ||
                                            '') || '-'
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <span class="col-12 font-weight-bold font-small-5 text-muted">Kode dan Nama Barang
                                    Seharusnya</span>
                                <div class="col-12 mt-50">
                                    <div class="border border-1 rounded p-75 bg-light">
                                        <span>{{ (formDatas.kobar_seharusnya || '') + ' - ' + (formDatas.nabar_seharusnya ||
                                            '')
                                            || '-'
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Terindikasi Register Gelondongan</span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0" style="gap:10px">
                        <b-form-radio v-model="formDatas.gelondongan" value="gelondongan" disabled>
                            Ya
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.gelondongan" value="non-gelondongan" disabled>
                            Tidak
                        </b-form-radio>
                    </div>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Bahan</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ (formDatas.bahan || '') + ' - ' + (formDatas.nama_bahan_siera || '') || '-' }}</span>
                    </div>
                    <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                        <b-form-radio v-model="formDatas.is_m_bahan" value="sesuai" disabled>
                            Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.is_m_bahan" value="tidak-sesuai" disabled>
                            Tidak Sesuai
                        </b-form-radio>
                    </div>
                    <template v-if="formDatas.is_m_bahan == 'tidak-sesuai'">
                        <div style="margin-left: 25px;">
                            <div class="row mb-2">
                                <span class="col-12 font-weight-bold font-small-5 text-muted">Bahan Seharusnya</span>
                                <div class="col-12 mt-50">
                                    <div class="border border-1 rounded p-75 bg-light">
                                        <span>{{ (formDatas.bahan_seharusnya || '') + ' - ' + (formDatas.nama_bahan || '')
                                            ||
                                            '-'
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <hr />
            <!-- IF KDO -->
            <template v-if="formDatas.kdo_mobile">
                <div class="row mb-2">
                    <span class="col-12 font-weight-bold font-small-5 text-muted">Nomor Polisi</span>
                    <div class="col-12 mt-50">
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.nopol || '-' }}</span>
                        </div>
                        <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                            <b-form-radio v-model="formDatas.m_nopol" value="sesuai" disabled>
                                Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.m_nopol" value="tidak-sesuai" disabled>
                                Tidak Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.m_nopol" value="tidak-ada" disabled>
                                Tidak Ada Nopol
                            </b-form-radio>
                        </div>
                        <template v-if="formDatas.m_nopol == 'tidak-sesuai'">
                            <div class="text-muted">Seharusnya</div>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nopol_seharusnya || '-' }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <hr />
                <div class="row mb-2">
                    <span class="col-12 font-weight-bold font-small-5 text-muted">Nomor Mesin</span>
                    <div class="col-12 mt-50">
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.nomesin_samsat || formDatas.nomesin_samsat || formDatas.nomesin || '-'
                            }}</span>
                        </div>
                        <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                            <b-form-radio v-model="formDatas.is_m_nomor_mesin" value="sesuai" disabled>
                                Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_m_nomor_mesin" value="tidak-sesuai" disabled>
                                Tidak Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_m_nomor_mesin" value="tidak-ada" disabled>
                                Tidak Ada Nomor
                            </b-form-radio>
                        </div>
                        <template v-if="formDatas.is_m_nomor_mesin == 'tidak-sesuai'">
                            <div class="text-muted">Seharusnya</div>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nomor_mesin_seharusnya || '-' }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <hr />
                <div class="row mb-2">
                    <span class="col-12 font-weight-bold font-small-5 text-muted">Nomor Rangka</span>
                    <div class="col-12 mt-50">
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.norangka_samsat || formDatas.nochasis || '-' }}</span>
                        </div>
                        <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                            <b-form-radio v-model="formDatas.is_m_nomor_rangka" value="sesuai" disabled>
                                Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_m_nomor_rangka" value="tidak-sesuai" disabled>
                                Tidak Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.is_m_nomor_rangka" value="tidak-ada" disabled>
                                Tidak Ada Nomor Rangka
                            </b-form-radio>
                        </div>
                        <template v-if="formDatas.is_m_nomor_rangka == 'tidak-sesuai'">
                            <div class="text-muted">Seharusnya</div>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.nomor_rangka_seharusnya || '-' }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <hr />
                <div class="row mb-2">
                    <span class="col-12 font-weight-bold font-small-5 text-muted">Nomor BPKB</span>
                    <div class="col-12 mt-50">
                        <div class="border border-1 rounded p-75 bg-light mb-1">
                            <span>{{ formDatas.nobpkb_samsat || formDatas.nobpkb || '-' }}</span>
                        </div>
                        <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                            <b-form-radio v-model="formDatas.m_bpkb" value="sesuai" disabled>
                                Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.m_bpkb" value="tidak-sesuai" disabled>
                                Tidak Sesuai
                            </b-form-radio>
                            <b-form-radio v-model="formDatas.m_bpkb" value="tidak-ada" disabled>
                                Tidak Ada Nomor BPKB
                            </b-form-radio>
                        </div>
                        <template v-if="formDatas.m_bpkb == 'tidak-sesuai'">
                            <div class="text-muted">Seharusnya</div>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.bpkb_seharusnya || '-' }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <hr />
            </template>
            <!-- END IF KDO -->
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Merk</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.merk_samsat || formDatas.merk || '-' }}</span>
                    </div>
                    <div v-if="!formDatas.kdo_mobile" class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                        <b-form-radio v-model="formDatas.m_merk" value="sesuai" disabled>
                            Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.m_merk" value="tidak-sesuai" disabled>
                            Tidak Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.m_merk" value="tidak-ada" disabled>
                            Tidak Ada Merk
                        </b-form-radio>
                    </div>
                    <div v-if="formDatas.m_merk == 'tidak-sesuai'" class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.merk_seharusnya || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Tipe</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.tipe_samsat || formDatas.tipe || '-' }}</span>
                    </div>
                    <div v-if="!formDatas.kdo_mobile" class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                        <b-form-radio v-model="formDatas.m_tipe" value="sesuai" disabled>
                            Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.m_tipe" value="tidak-sesuai" disabled>
                            Tidak Sesuai
                        </b-form-radio>
                        <b-form-radio v-model="formDatas.m_tipe" value="tidak-ada" disabled>
                            Tidak Ada Tipe
                        </b-form-radio>
                    </div>
                    <div v-if="formDatas.m_tipe == 'tidak-sesuai'" class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.tipe_seharusnya || '-' }}</span>
                    </div>
                </div>
            </div>
            <div v-if="formDatas.ganda == 'iya'" class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Keterangan Ganda</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.bahan_seharusnya || '-' }}</span>
                    </div>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Penggunaan Barang</span>
                <div class="col-12 mt-50">
                    <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                        <b-form-radio v-model="formDatas.penggunaan" value="digunakan-sendiri" disabled>
                            Digunakan Sendiri
                        </b-form-radio>
                        <div v-if="formDatas.penggunaan == 'digunakan-sendiri' && formDatas.digunakan_sendiri_mobile"
                            style="margin-left: 25px;">
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Nama Pemakai</span>
                                <div class="border border-1 rounded p-75 bg-light mb-1">
                                    <span>{{ formDatas.nama_pengguna || '-' }}</span>
                                </div>
                            </div>
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Status Pemakai</span>
                                <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                                    <b-form-radio v-model="formDatas.status_pemakai_pengguna" value="asn" disabled>
                                        ASN
                                    </b-form-radio>
                                    <b-form-radio v-model="formDatas.status_pemakai_pengguna" value="non-asn" disabled>
                                        NON ASN
                                    </b-form-radio>
                                </div>
                            </div>
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">BAST Pemakai/Dokumen Lainnya</span>
                                <div class="d-flex flex-column mt-50 mt-md-0 mb-1" style="gap:10px">
                                    <b-form-radio v-model="formDatas.is_bast_pengguna" value="ya" disabled>
                                        ADA
                                    </b-form-radio>
                                    <b-form-radio v-model="formDatas.is_bast_pengguna" value="tidak" disabled>
                                        TIDAK ADA
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>
                        <b-form-radio v-model="formDatas.penggunaan" value="pd-ukpd-lain" disabled>
                            PD/UKPD Lain
                        </b-form-radio>
                        <div v-if="formDatas.penggunaan == 'pd-ukpd-lain'" style="margin-left: 25px;">
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Nama PD/UKPD</span>
                                <div class="border border-1 rounded p-75 bg-light mb-1">
                                    <span>{{ (formDatas.kolok_pengguna || '') + ' - ' + (formDatas.nalok_pengguna || '') ||
                                        '-'
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <b-form-radio v-model="formDatas.penggunaan" value="pemerintah-pusat" disabled>
                            Pemerintah Pusat
                        </b-form-radio>
                        <div v-if="formDatas.penggunaan == 'pemerintah-pusat'" style="margin-left: 25px;">
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Nama Instansi</span>
                                <div class="border border-1 rounded p-75 bg-light mb-1">
                                    <span>{{ formDatas.nama_pengguna || '-' }}</span>
                                </div>
                            </div>
                        </div>
                        <b-form-radio v-model="formDatas.penggunaan" value="pemerintah-daerah-lain" disabled>
                            Pemerintah Daerah Lain
                        </b-form-radio>
                        <div v-if="formDatas.penggunaan == 'pemerintah-daerah-lain'" style="margin-left: 25px;">
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Nama Instansi</span>
                                <div class="border border-1 rounded p-75 bg-light mb-1">
                                    <span>{{ formDatas.nama_pengguna || '-' }}</span>
                                </div>
                            </div>
                        </div>
                        <b-form-radio v-model="formDatas.penggunaan" value="pihak-lain" disabled>
                            Pihak Lain
                        </b-form-radio>
                        <div v-if="formDatas.penggunaan == 'pihak-lain'" style="margin-left: 25px;">
                            <div>
                                <span class="font-weight-bold font-small-5 text-muted">Nama Pihak Lain</span>
                                <div class="border border-1 rounded p-75 bg-light mb-1">
                                    <span>{{ formDatas.nama_pengguna || '-' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Keterangan</span>
                <div class="col-12 mt-50">
                    <div class="border border-1 rounded p-75 bg-light mb-1">
                        <span>{{ formDatas.keterangan || '-' }}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="formDatas.ganda == 'iya'">
            <div class="row mb-1">
                <div class="col-12">
                    <div class="font-weight-bold text-muted">Pada PD/UKPD/UPB</div>
                </div>
                <div class="col-12">
                    <div>
                        {{ (formDatas.kolok || '') + '-' +
                            (formDatas.nalok || '') }}
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-12">
                    <div class="font-weight-bold text-muted">Foto Barang</div>
                </div>
                <div class="col-12">
                    <ImageView :imgUrl="formDatas.file_foto_barang || ''" />
                </div>
            </div>
            <hr />
            <div class="row mb-2">
                <span class="col-12 font-weight-bold font-small-5 text-muted">Pendataan dilakukan pada</span>
                <div class="col-12 mt-50 overflow-auto rounded">
                    <template v-if="formDatas.keberadaan == 'luar'">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Lokasi ID</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.lokasi_id || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Jalan / Nomor</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.jalan || '-' }} / {{ formDatas.detail_lokasi.no_jalan ||
                                    '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">RT / RW</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.rt || '-' }} / {{ formDatas.detail_lokasi.rw || '-'
                                }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kelurahan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_kel || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kecamatan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_kec || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kota / Kabupaten</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.nm_rayon || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Kode Pos</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_lokasi.kodepos || '-' }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="formDatas.keberadaan == 'dalam'">
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Ruangan ID</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.ruangan_id || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Gedung</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{
                                    `${(formDatas.detail_ruangan.kolok_gedung) ? formDatas.detail_ruangan.kolok_gedung :
                                        ''}${(formDatas.detail_ruangan.nalok_gedung) ? '::' +
                                            formDatas.detail_ruangan.nalok_gedung :
                                            ''}${(formDatas.detail_ruangan.noreg_gedung) ? '::' +
                                                formDatas.detail_ruangan.noreg_gedung :
                                                ''}${(formDatas.detail_ruangan.alamat_gedung) ? '::' +
                                                    formDatas.detail_ruangan.alamat_gedung : ''} ` || '-' }}
                                </span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Lantai</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.lantai || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Jenis Ruangan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.jenis_ruangan_nama || '-' }}</span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold font-small-5 text-muted">Nama Ruangan</span>
                            <div class="border border-1 rounded p-75 bg-light mb-1">
                                <span>{{ formDatas.detail_ruangan.nama_ruangan || '-' }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
import { ref, watch, watchEffect, onMounted } from '@vue/composition-api'
import { id as localeId } from "vee-validate/dist/locale/id";
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { parserValue } from '@/libs/helper'
import ImageView from '@/components/base/ImageView'
export default {
    props: {
        fD: {
            type: Object,
            required: true,
        },
        disabled: { type: Boolean, default: false },
    },
    setup(props, context) {
        const g = context.root;
        const formDatas = ref({});
        watchEffect(() => {
            formDatas.value = props.fD
        });
        return {
            formDatas,
        }
    },
    computed: {
    },
    components: {
        ImageView
    },
    directives: {
        Ripple,
    },
    methods: {
    },

    data() {
        return {
            required,
        }
    },
}
</script>

<style lang="scss" scope>
.custom-control.custom-radio input:checked+.custom-control-label::before {
    /* Change this color to the desired color for the checked radio button */
    background-color: var(--indigo) !important;
}

.custom-control.custom-radio input:checked+.custom-control-label {
    /* Change this color to the desired color for the label text when checked */
    color: var(--text-dark) !important;
}
</style>